import { useMediaQuery } from '@mui/material';

const useMedium = props => {
  const isMd = useMediaQuery(theme => theme?.breakpoints?.down('lg'));
  return isMd;
};

export default useMedium;
